import React, {Fragment} from 'react';
import CardContainerForm from '../../components/CardContainerForm';
import Form from '../../components/forms/PlaceOfSale';

export default function RegularTables1(props) {
  return (
    <>
      <CardContainerForm>
        <Form openAlert={props.openAlert} pms={props.pms} />
      </CardContainerForm>
    </>
  );
}
